/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Editor_Add_FbInputs */

const en_link_editor_add_fb = /** @type {(inputs: Link_Editor_Add_FbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add FB`)
};

const es_link_editor_add_fb = /** @type {(inputs: Link_Editor_Add_FbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir FB`)
};

const fr_link_editor_add_fb = /** @type {(inputs: Link_Editor_Add_FbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter FB`)
};

const de_link_editor_add_fb = /** @type {(inputs: Link_Editor_Add_FbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FB hinzufügen`)
};

/** @type {(inputs: Link_Editor_Add_FbInputs) => LocalizedString} */
const ja_link_editor_add_fb = en_link_editor_add_fb;

/** @type {(inputs: Link_Editor_Add_FbInputs) => LocalizedString} */
const zh_link_editor_add_fb = en_link_editor_add_fb;

/** @type {(inputs: Link_Editor_Add_FbInputs) => LocalizedString} */
const ar_link_editor_add_fb = en_link_editor_add_fb;

/** @type {(inputs: Link_Editor_Add_FbInputs) => LocalizedString} */
const id_link_editor_add_fb = en_link_editor_add_fb;

/** @type {(inputs: Link_Editor_Add_FbInputs) => LocalizedString} */
const it_link_editor_add_fb = en_link_editor_add_fb;

/** @type {(inputs: Link_Editor_Add_FbInputs) => LocalizedString} */
const ru_link_editor_add_fb = en_link_editor_add_fb;

/** @type {(inputs: Link_Editor_Add_FbInputs) => LocalizedString} */
const pt_link_editor_add_fb = en_link_editor_add_fb;

/** @type {(inputs: Link_Editor_Add_FbInputs) => LocalizedString} */
const ko_link_editor_add_fb = en_link_editor_add_fb;

/**
* | output |
* | --- |
* | "Add FB" |
*
* @param {Link_Editor_Add_FbInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_editor_add_fb = /** @type {((inputs?: Link_Editor_Add_FbInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Editor_Add_FbInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_editor_add_fb(inputs)
	if (locale === "es") return es_link_editor_add_fb(inputs)
	if (locale === "fr") return fr_link_editor_add_fb(inputs)
	if (locale === "de") return de_link_editor_add_fb(inputs)
	if (locale === "ja") return ja_link_editor_add_fb(inputs)
	if (locale === "zh") return zh_link_editor_add_fb(inputs)
	if (locale === "ar") return ar_link_editor_add_fb(inputs)
	if (locale === "id") return id_link_editor_add_fb(inputs)
	if (locale === "it") return it_link_editor_add_fb(inputs)
	if (locale === "ru") return ru_link_editor_add_fb(inputs)
	if (locale === "pt") return pt_link_editor_add_fb(inputs)
	return ko_link_editor_add_fb(inputs)
});